import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { HIGH_SCORE, LOW_SCORE, MEDIUM_SCORE } from '../../../../../../../helpers/helpers';

interface IDot {
  cx: number;
  cy: number;
  value: number;
  threshold_values?: {
    high: number;
    low: number;
    medium: number;
  };
  onClick?: () => void;
}

const Dot: FC<IDot> = ({ cx, cy, value, threshold_values, onClick }) => {
  const theme = useTheme();
  const { high = HIGH_SCORE, low = LOW_SCORE, medium = MEDIUM_SCORE } = threshold_values || {};

  const COLOR =
    value > high
      ? theme.colors.accent.green[100]
      : value > medium
        ? theme.colors.accent.blue[100]
        : value >= low
          ? theme.colors.accent.orange[70]
          : theme.colors.accent.red[100];

  return (
    <g onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <circle cx={cx} cy={cy} r={24} fill={COLOR} />
      <text
        x={cx}
        y={cy + 4}
        fill={theme.colors.neutral.primary[0]}
        fontSize="12"
        fontWeight="700"
        textAnchor="middle"
      >
        {value.toFixed(1)}
      </text>
    </g>
  );
};

export default Dot;
